import { styled } from 'styled-components';
import { SelectedItemIndicatorDiv } from '../SegmentedControl/SelectedItemIndicator';

export const TabsSelectedItemIndicatorDiv = styled(SelectedItemIndicatorDiv)`
  :has(button[role='tab']:focus-visible) > & {
    outline: 2px solid var(--wui-color-focus-ring);
  }
`;
